export default {
  name: "Wast",
  mail: "info@wast.fr",
  phone: {
    raw: "+33182834480",
    formatted: "+33 1 82 83 44 80",
  },
};
